import { ColorVariants } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

export interface SecondaryPalette {
  secondary: ColorVariants;
}

export const PaletteTheme: Partial<DefaultTheme["palette"]> = {
  background: "#FFFFFF",
  primary: {
    700: "#B3A300",
    600: "#CAB800",
    500: "#E0CC00",
    100: "#F5EFB0",
    50: "#FCFAE6",
  },
  secondary: {
    700: "#2FAA8B",
    600: "#35BF9D",
    500: "#3BD4AE",
    100: "#C2F2E6",
    50: "#EBFBF7",
  },
  common: {
    white: "#FFFFFF",
    black: "#1D1D1D",
  },
};
